import moment from "moment-timezone";

export const setDefaultTimezone = response => {
  if (response && response.timeZoneSetting) {
    moment.tz.setDefault(response.timeZoneSetting.userTZ);
  }
};



// WEBPACK FOOTER //
// ./actions/helpers/loginHelper.js